import { render, staticRenderFns } from "./PriceOffersSection.vue?vue&type=template&id=2c66b7cc&scoped=true"
import script from "./PriceOffersSection.vue?vue&type=script&lang=ts"
export * from "./PriceOffersSection.vue?vue&type=script&lang=ts"
import style0 from "./PriceOffersSection.vue?vue&type=style&index=0&id=2c66b7cc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c66b7cc",
  null
  
)

export default component.exports